"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toLocalInteraction = toLocalInteraction;
exports.toInteractionRecord = toInteractionRecord;

var _immutable = require("immutable");

var _translate = _interopRequireDefault(require("transmute/translate"));

var _EmailAddressRecord = _interopRequireDefault(require("customer-data-email/schema/email/EmailAddressRecord"));

/*
  Transforms an `InteractionRecord` to a `LocalInteraction` for local storage.
  Interactions that require more than this should write additional transforms.
*/
var KEYS = (0, _immutable.Seq)(['subject', 'ccs', 'bccs', 'from', 'to', 'templateId']);

var toLowerCaseAddress = function toLowerCaseAddress(from) {
  var address = from.get('address');
  return address ? from.set('address', address.toLowerCase()) : null;
};

var emailTranslation = {
  subject: true,
  ccs: function ccs(email) {
    return email.get('ccs').map(function (cc) {
      return new _EmailAddressRecord.default(cc);
    });
  },
  bccs: function bccs(email) {
    return email.get('bccs').map(function (bcc) {
      return new _EmailAddressRecord.default(bcc);
    });
  },
  from: function from(email) {
    return new _EmailAddressRecord.default(toLowerCaseAddress(email.get('from')));
  },
  to: function to(email) {
    var toEmails = email.get('to');

    if (!_immutable.List.isList(toEmails)) {
      toEmails = (0, _immutable.List)([toEmails]);
    }

    return toEmails.map(function (to) {
      return new _EmailAddressRecord.default(to);
    });
  },
  templateId: true
};

function toLocalInteraction(interactionRecord, localInteraction) {
  return localInteraction.set('email', interactionRecord.metadata.filter(function (__, key) {
    return KEYS.includes(key);
  }));
}

function toInteractionRecord(localInteraction, interactionRecord) {
  var email = localInteraction.get('email');

  if (!email) {
    return interactionRecord;
  }

  var metadata = interactionRecord.metadata.merge((0, _translate.default)(emailTranslation, email));
  return interactionRecord.set('metadata', metadata);
}